const menu = document.querySelector(".menu-mobile-tab");
const menuButton = document.querySelector(".menu-button");
const menuOverlay = document.querySelector(".menu-mobile-overlay");
// De/activate the mobile menu and button as required
const menuToggle = toggle => {
  toggle =
    toggle != undefined
      ? toggle
      : !(menu.getAttribute("aria-expanded") == "true");
  menuButton.setAttribute("aria-expanded", toggle);
  menu.setAttribute("aria-expanded", toggle);
};
menuButton &&
  menuButton.addEventListener("click", e => {
    e.preventDefault();
    menuToggle();
  });
menuOverlay &&
  menuOverlay.addEventListener("click", e => {
    menuToggle(false);
  });
